/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';


/* UPLOAD FILE */
export const UPLOAD_SET = 'UPLOAD_SET';
export const UPLOAD_SET_SUCCESS = 'UPLOAD_SET_SUCCESS';
export const UPLOAD_SET_ERROR = 'UPLOAD_SET_ERROR';
export const UPLOAD_RESET = 'UPLOAD_RESET';


/* FORM UPLOAD FILE */
export const FORM_UPLOAD_SET = 'FORM_UPLOAD_SET';
export const FORM_UPLOAD_SET_SUCCESS = 'FORM_UPLOAD_SET_SUCCESS';
export const FORM_UPLOAD_SET_ERROR = 'FORM_UPLOAD_SET_ERROR';
export const FORM_UPLOAD_RESET = 'FORM_UPLOAD_RESET';

/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/*MAIN*/
export const SUPPLIER_LIST = 'SUPPLIER_LIST';
export const SUPPLIER_LIST_SUCCESS = 'SUPPLIER_LIST_SUCCESS';
export const SUPPLIER_LIST_ERROR = 'SUPPLIER_LIST_ERROR';
export const ADD_FORM = 'ADD_FORM';
export const ADD_FORM_SUCCESS = 'ADD_FORM_SUCCESS';
export const ADD_FORM_ERROR = 'ADD_FORM_ERROR';

export * from './main/actions';





export * from './menu/actions';
export * from './settings/actions';
export * from './upload/actions';
export * from './auth/actions';





